import type { WorkflowIssue } from "./workflow-validation"

export type WorkflowSaveValidationAction = "block" | "warn" | "save"

export function getWorkflowSaveValidationAction({
  blockingIssue,
  hasMissingProcessorWarning,
}: {
  blockingIssue: WorkflowIssue | null | undefined
  hasMissingProcessorWarning: boolean
}): WorkflowSaveValidationAction {
  if (blockingIssue) return "block"
  if (hasMissingProcessorWarning) return "warn"
  return "save"
}
